
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M2.65 15h12.7a1.5 1.5 0 001.287-2.272l-6.35-10.584a1.5 1.5 0 00-2.573 0L1.363 12.728A1.5 1.5 0 002.649 15z","fill":"#E0255E"}}),_c('path',{attrs:{"d":"M9.832 12.38a.845.845 0 11-1.692 0 .845.845 0 111.692 0zM10.156 5.98l-.018.145-.46 3.816a.703.703 0 01-1.403 0l-.46-3.816V5.98c0-.477.523-.855 1.17-.855.649 0 1.17.378 1.17.855z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    